import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet, Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { getAccessToken } from '../../api/client';
import { useNotifications } from '../../hooks/useNotifications';
export function AuthGuard() {
    const { isAuthenticated } = useAppSelector((s) => s.auth);
    const token = getAccessToken();
    // Real-time notifications on ALL authenticated pages
    useNotifications();
    // If no token and not authenticated → redirect to landing
    if (!token && !isAuthenticated) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(Outlet, {});
}
